module.exports = __webpack_public_path__ + "common/icon-question-white-eacc6f381a4a1a03b0507e1e3a8be69c.svg";